import { Fragment, useState } from "react";
import { FormattedMessage as FM } from "react-intl";
import { signal } from "@preact/signals-react";

import BasicModal from "components/Modals/BasicModal2";
import ModalMsg from "components/Modals/ModalMsg";
import { BUTTON_COLORS } from "components/Constants/constants";
import { cn } from "tools/ui";
import mainStore from "store/mainStore";
import { useWizardStore } from "store/wizardStore";
import { useBtnLoading } from "store/btnLoading";

const styleBase =
  "flex space-x-3 justify-center items-center my-4 p-2 h-12 text-center border-[1px] rounded-xl shadow-md active:scale-95 active:shadow-lg";

function ModalWizard(props) {
  const open = signal(false);
  const { field, attrs } = props;
  const { label, model, icon, color } = field;
  const { ctxView, record, parentRec, style } = attrs;
  const Component = field.Component;
  const [msg, setMsg] = useState(null);
  const { record: recordMain, reload } = mainStore.getState();
  const { triggerReset } = useWizardStore.getState();
  const { setButtonLoading } = useBtnLoading();

  const _color = color ?? "blue";
  const [bgColor, txtColor, border] = BUTTON_COLORS[_color];

  function onCloseMsg() {
    setMsg(null);
  }

  async function onClose(update, error) {
    if (error) {
      setMsg(error);
      // reset();
      return;
    }
    setButtonLoading(false);

    if (update && recordMain.id > 0) {
      await reload();
    }
    open.value = false;
    if (triggerReset) {
      triggerReset();
    }
  }

  function openModal() {
    if (field.resetWizard) {
      // reset();
    }
    if (ctxView?.defaults) {
      // This method set default values for the wizard
      ctxView.defaults();
    }
    open.value = true;
  }

  let mxLabel = "mx-auto";
  if (icon) {
    mxLabel = "";
  }

  return (
    <Fragment>
      <button
        onClick={openModal}
        className={cn(styleBase, bgColor, txtColor, border)}
      >
        <span className={cn("w-fit my-auto", mxLabel)}>
          <FM id={label} />
        </span>
        {icon && icon}
      </button>
      <BasicModal
        title={label}
        openModal={open}
        closeModal={onClose}
        buttons={[]}
        titleSize="text-2xl"
        style={style}
      >
        <Component
          parentRec={record}
          model={model}
          record={{}}
          onClose={onClose}
          ctxView={ctxView}
          wizardOpen={open}
        />
      </BasicModal>
      {msg && (
        <ModalMsg
          open={true}
          type="error"
          msg={msg}
          buttons={["close"]}
          onClose={onCloseMsg}
        />
      )}
    </Fragment>
  );
}

export default ModalWizard;
